module.exports = __webpack_public_path__ + "img/growcify-dashboard-banner-8.2a531283.png";